import { a as m, B as C } from "./chunk-BaseElement-BuXbltG-.js";
import { d as f, O as b } from "./chunk-debounce-Bk6yKvzA.js";
import { W as u } from "./chunk-WithShopifyCart-CoFAHix4.js";
import { t as p } from "./chunk-custom-element-ttkHUa8w.js";
import { x as E } from "./chunk-lit-element-CNHURX5C.js";
import { n as _ } from "./chunk-property-Baio2yOX.js";
import "./chunk-quantity-input-ChjjQqAA.js";
import { f as A } from "./chunk-firstFocusableElement-B5e7Zq7o.js";
import { a as v } from "./chunk-gqlOperations-D4wOnjh5.js";
import { H as g } from "./chunk-HTMLUpdateUtility-pt0dDGgp.js";
import { W as S } from "./chunk-WithApiClient-Da1nY1F5.js";
import { e as y } from "./chunk-query-pk3khlGb.js";
var O = Object.defineProperty, T = Object.getOwnPropertyDescriptor, w = (e, t, r, n) => {
  for (var s = n > 1 ? void 0 : n ? T(t, r) : t, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (s = (n ? a(t, r, s) : a(s)) || s);
  return n && s && O(t, r, s), s;
};
let h = class extends u(
  m
) {
  constructor() {
    super(), this._handleInput = this._handleInput.bind(this), this._handleInputDebounced = f(
      this._handleInput,
      b
    );
  }
  connectedCallback() {
    super.connectedCallback(), this.addEventListener("input", this._handleInputDebounced);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("input", this._handleInputDebounced);
  }
  _handleInput(e) {
    const t = e.target.value;
    this.updateCartNoteAndAttributes({ note: t }, { sections: !1 });
  }
};
h = w([
  p("cart-note")
], h);
var $ = Object.defineProperty, P = Object.getOwnPropertyDescriptor, I = (e, t, r, n) => {
  for (var s = n > 1 ? void 0 : n ? P(t, r) : t, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (s = (n ? a(t, r, s) : a(s)) || s);
  return n && s && $(t, r, s), s;
};
let c = class extends u(C) {
  _handleClick(e) {
    e.preventDefault(), this.key && this.removeItemFromCart(this.key);
  }
  render() {
    return E` <slot @click=${this._handleClick}></slot> `;
  }
};
I([
  _({ type: String })
], c.prototype, "key", 2);
c = I([
  p("cart-remove-toggle")
], c);
var D = Object.defineProperty, U = Object.getOwnPropertyDescriptor, l = (e, t, r, n) => {
  for (var s = n > 1 ? void 0 : n ? U(t, r) : t, i = e.length - 1, a; i >= 0; i--)
    (a = e[i]) && (s = (n ? a(t, r, s) : a(s)) || s);
  return n && s && D(t, r, s), s;
};
let o = class extends u(
  S(m)
) {
  constructor() {
    super(...arguments), this.$htmlUpdateUtility = new g(this), this.cart = window.__CART__;
  }
  connectedCallback() {
    super.connectedCallback(), this.addItem = this.addItem.bind(this), this._addItemDebounced = f(this.addItem, b), this.$htmlUpdateUtility.addPostProcessCallback(() => {
      var e, t;
      (t = (e = window == null ? void 0 : window.Shopify) == null ? void 0 : e.PaymentButton) == null || t.init(), this.lastFocusedElementSelectorId && setTimeout(() => {
        var n;
        const r = document.querySelector(
          `#${this.lastFocusedElementSelectorId}`
        );
        r ? r == null || r.focus() : (n = A(this)) == null || n.focus(), this.lastFocusedElementSelectorId = null;
      }, 50), this.prepareUpsells();
    }), this.prepareUpsells();
  }
  prepareUpsells() {
    if (!this.upsellElement)
      return;
    JSON.parse(
      this.upsellElement.getAttribute("data-upsell-ids") || "[]"
    ).forEach((t) => {
      this.getSection(t);
    });
  }
  async getSection(e) {
    const t = this.upsellElement.getAttribute("data-section-id"), r = this.upsellElement.getAttribute("data-base-url"), n = this.upsellElement.getAttribute("data-intent") || "complementary";
    if (!t || !r)
      return;
    const s = `${r}?product_id=${e}&limit=4&intent=${n}&section_id=${t}`;
    fetch(s, {
      method: "GET"
    }).then((i) => i.text()).then((i) => {
      const d = new DOMParser().parseFromString(i, "text/html").getElementById(
        `shopify-section-${t}`
      );
      this.upsellElement.innerHTML = this.upsellElement.innerHTML + (d == null ? void 0 : d.innerHTML);
    }).then(() => {
      var i, a;
      this.upsellElement.innerHTML.length > 0 ? (i = this.upsellElement.parentElement) == null || i.setAttribute("data-loaded", "true") : (a = this.upsellElement.parentElement) == null || a.setAttribute("data-loaded", "false"), this.hydrateAddToCart();
    }).catch((i) => {
      console.error(i);
    });
  }
  hydrateAddToCart() {
    this.querySelectorAll("[data-upsell-add]").forEach((e) => {
      e.removeEventListener("click", this._addItemDebounced), e.addEventListener("click", this._addItemDebounced);
    });
  }
  addItem(e) {
    if (!e.target)
      return;
    const t = e.target, r = t.getAttribute("data-upsell-add");
    if (!r)
      return;
    const s = [{
      id: r,
      quantity: 1
    }];
    t.setAttribute("disabled", "true"), t.setAttribute("aria-disabled", "true"), this.addItemToCart(s).then(() => {
      t.removeAttribute("disabled"), t.removeAttribute("aria-disabled");
    });
  }
  updateAttributes(e) {
    if (!this.cart || !e) return;
    const t = this.cart.attributes, r = e ? e.includes(",") ? e.split(",").map((i) => i.trim()) : [e] : [];
    if (!r.some(
      (i) => i in t
    )) return;
    const s = Object.fromEntries(
      Object.entries(t).map(([i, a]) => [
        i,
        r.includes(i) ? "" : a
      ])
    );
    this.updateCartNoteAndAttributes(
      {
        attributes: s
      },
      {
        sections: !0
      }
    );
  }
  async clearBuyerIdentity() {
    this.cart.token || (this.cart = await this.getCart());
    const e = {
      preferences: {
        delivery: {
          deliveryMethod: null,
          pickupHandle: null
        }
      }
    };
    if (!await this.$api.client.storefront({
      body: {
        query: v,
        variables: {
          id: `gid://shopify/Cart/${this.cart.token}`,
          buyerIdentity: e
        }
      }
    }))
      throw new Error("No data returned from API");
  }
  updated() {
    var e;
    if (this.cartSections[this.sectionId] && JSON.stringify(this.cartSections[this.sectionId]) !== o.SECTIONS_CACHE[this.sectionId]) {
      this.cart = window.__CART__, o.SECTIONS_CACHE[this.sectionId] = JSON.stringify(
        this.cartSections[this.sectionId]
      );
      const t = this.$htmlUpdateUtility.parseSectionStringForSelector(
        this.cartSections[this.sectionId],
        "#cart-drawer-render-target"
      );
      if (t && this.$htmlUpdateUtility.replace(this.sectionRenderTarget, t), t != null && t.hasAttribute("data-empty")) {
        const r = ((e = t.getAttribute("data-empty-attributes")) == null ? void 0 : e.trim()) || null;
        this.updateAttributes(r), this.clearBuyerIdentity();
      }
    }
  }
};
o.SECTIONS_CACHE = {};
l([
  _({ type: String, attribute: "section-id" })
], o.prototype, "sectionId", 2);
l([
  y("#cart-drawer-render-target")
], o.prototype, "sectionRenderTarget", 2);
l([
  y("[data-upsell-ids]")
], o.prototype, "upsellElement", 2);
o = l([
  p("cart-sections")
], o);
export {
  o as CartSections
};
